import Papa from "papaparse";
import Cookies from "js-cookie";
import { getDoc } from "../../API/DocList";
import getDocs from "../../AdminAPI/DocsADM";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { docAttachment } from "../../API/DocAttachment";
import { useTranslation } from "react-i18next";
import { attachZipADM } from "../../AdminAPI/AttachZipADM";
import i18n from "../../Langues/i18n";

//fonction de composant pour télécharger un fichier CSV
const DownloadCSVFile = ({ data }) => {
  const handleDownloadCSV = () => {
    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "instances.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const { t } = useTranslation();

  return (
    <div>
      <button
        className="btn bg-light"
        title={t("Download all instances")}
        data-toogle="tooltip"
        onClick={handleDownloadCSV}
      >
        <FontAwesomeIcon icon={faFileCsv} className="fa-copy" />
      </button>
    </div>
  );
};

// Fonction de composant pour télécharger un document CSV spécifique.
const DownloadCSVDoc = ({ item }) => {
  const handleDownloadCSVDoc = async () => {
    const role = Cookies.get("Role");
    try {
      const idToken = Cookies.get("Token");
      let docData;
      if (role == "superadmin") {
        docData = await getDocs(
          item.kInstanceId,
          item.kClientId,
          idToken
        );
      } else {
        docData = await getDoc(idToken, item.kInstanceId);
      }

      if (!docData || docData.length === 0) {
        toast.error(t("No document in this instance"));
        return console.error("no document in this instance");
      }
      const instanceHead = Object.keys(item).join(";");
      const instanceResult = Object.values(item).join(";");
      const docsHead = Object.keys(docData[0]).join(";");
      const docsResult = docData
        .map((obj) =>
          Object.values(obj)
            .map((v) =>
              typeof v === "object" && v !== null ? JSON.stringify(v) : v
            )
            .join(";")
        )
        .join("\n");

      const csvString = `${instanceHead}\n${instanceResult}\n${docsHead}\n${docsResult}`;
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "allDocs.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erreur lors du téléchargement du fichier CSV :", error);
    }
  };

  const { t } = useTranslation();

  return (
    <div>
      <button
        className="btn"
        onClick={handleDownloadCSVDoc}
        data-toggle="tooltip"
        title={t("Download instance")}
      >
        <FontAwesomeIcon icon={faFileCsv} className="fa-copy" />
      </button>
    </div>
  );
};

// Utilise la fonction `attachZip` pour gérer le téléchargement et affiche des notifications en fonction du résultat
export const handleUpload = async (
  selectedFile,
  instanceId,
  selectedDocumentId,
  modelId,
  fileExtension,
  attachZip,
  closeModal,
  setSelectedFile
) => {
  if (!selectedFile) {
    toast.warn(i18n.t("Please select a file."), {
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    return;
  }

  const idToken = Cookies.get("Token");
  const role = Cookies.get("Role");
  try {
    if (role === "superadmin"){
      await attachZipADM(
        instanceId,
        selectedDocumentId,
        modelId,
        selectedFile,
        idToken,
        fileExtension
      )
    }else{
      await attachZip(
        instanceId,
        selectedDocumentId,
        modelId,
        selectedFile,
        idToken,
        fileExtension
      );
    }
    toast.success(i18n.t("File uploaded successfully."));
    window.location.reload();
    closeModal();
  } catch (error) {
    console.error("Erreur lors du téléchargement du fichier :", error);
    toast.error(i18n.t("Error uploading file:", { errorMessage: error.message }), {
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } finally {
    setSelectedFile(null);
  }
};

// Fonction pour télécharger des pièces jointes
export const handleDownload = async (docId, fileType, instanceId, modelId) => {
  try {
    const token = Cookies.get("Token");
    await docAttachment(token, instanceId, docId, fileType, modelId);
  } catch (error) {
    console.error("Erreur lors du téléchargement :", error);
  }
};

export { DownloadCSVFile, DownloadCSVDoc };
